import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';

class BalancingGroupSettingsComponentCtrl implements ng.IController {
    public settings: TsoSecondarySettingsDto;
    public balancingGroupPortfolioCodeSelection: BalancingGroupPortfolioCodeSelection;
    public tsoRefId: number;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {}

    public savePreventBalancingGroupForTransferOfUseTrades() {
        this.TransmissionSystemOperator.saveRequireBalancingGroupForTransferOfUseTrades(
            { id: this.tsoRefId },
            this.settings.preventBalancingGroupForTransferOfUse,
            (res) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.settings.preventBalancingGroupForTransferOfUse =
                    !this.settings.preventBalancingGroupForTransferOfUse;
                this.errorHandler(err);
            }
        );
    }
}

angular.module('app').component('pkpBalancingGroupSettings', {
    controller: BalancingGroupSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/balancing-group-settings.component.html'),
    bindings: {
        tsoRefId: '<',
        settings: '=',
        balancingGroupPortfolioCodeSelection: '<'
    }
});
